import {
  ComponentManagerService,
  FormService, ModalFormValueChange,
  MultiLineComponentTemplate,
  MultiLineFormModalComponent
} from "@fgpp-ui/components";
import {Component, OnDestroy, OnInit} from "@angular/core";
import {DocumentTemplate} from "../document-template.model";

@Component({
  selector: 'app-document-template-modal',
  template : MultiLineComponentTemplate.HTML_TEMPLATE,
  styles: [MultiLineComponentTemplate.STYLE_TEMPLATE],
  providers: [
    FormService,
    ComponentManagerService
  ]
})
export class DocumentTemplateModalComponent extends MultiLineFormModalComponent implements OnInit, OnDestroy {

  protected formLoadComplete() {
    super.formLoadComplete();
    const paymentCategory = this.formMgr.get(DocumentTemplate.PAYMENT_CATEGORY).getValue();
    if (paymentCategory && paymentCategory === 'Bank payment') {
      this.formMgr.get(DocumentTemplate.PAYMENT_TYPE).setValue('Domestic').disable();
      this.formMgr.get(DocumentTemplate.REGULATION).setValue('false').disable();
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected valueChanges(change: ModalFormValueChange): void {
    if (change.control === DocumentTemplate.PAYMENT_CATEGORY) {
      const paymentCategory = this.formMgr.get(DocumentTemplate.PAYMENT_CATEGORY).getValue();
      if (paymentCategory && paymentCategory === 'Bank payment') {
        this.formMgr.get(DocumentTemplate.PAYMENT_TYPE).setValue('Domestic').disable();
        this.formMgr.get(DocumentTemplate.REGULATION).setValue('false').disable();
      } else {
        this.formMgr.get(DocumentTemplate.PAYMENT_TYPE).reset().enable();
        this.formMgr.get(DocumentTemplate.REGULATION).reset().enable();

      }
    }
  }

}
